/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import type { EmbeddedContentProps } from 'bundles/compound-assessments/components/shared/embeddedContent/EmbeddedContent';
import EmbeddedLink from 'bundles/compound-assessments/components/shared/embeddedContent/EmbeddedLink';
import RenderPreviewTitle from 'bundles/compound-assessments/components/shared/embeddedContent/RenderPreviewTitle';
import RenderPreviewUnavailable from 'bundles/compound-assessments/components/shared/embeddedContent/RenderPreviewUnavailable';

const styles = {
  renderContainer: () => css`
    margin: var(--cds-spacing-200) 0;
    overflow: auto;
  `,
};

export const EmbeddedVideo: React.FC<EmbeddedContentProps> = ({ url, title }: EmbeddedContentProps) => {
  const [fileAvailable, setFileAvailable] = useState(true);
  return (
    <div>
      <EmbeddedLink url={url} title={title} />
      {fileAvailable ? (
        <div css={styles.renderContainer}>
          <RenderPreviewTitle />
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            src={url}
            title={title}
            width="100%"
            height="100%"
            controls={true}
            preload="metadata"
            onError={() => setFileAvailable(false)}
          />
        </div>
      ) : (
        // for audio/video validFileSize is just fileAvailability because we only pre-load metadata
        // and allow any size media to be played
        <RenderPreviewUnavailable fileAvailable={fileAvailable} validFileSize={fileAvailable} />
      )}
    </div>
  );
};

export const isEmbeddedVideo = (url: string) => {
  const regex = /\.(mp4|mov|m4v|webm|mkv)$/i;
  return url.match(regex);
};

export default EmbeddedVideo;
